export const gitHubLink = 'https://github.com/chebb44/rs-lang-24/tree/master';
